import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./styles.scss";
import ModalFrame from "../../../../toolkit/modalFrame";
import { MitInteliposDevice } from "../interfaces";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencilAlt,
  faPlus,
  faUserPlus
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Container, Button, UncontrolledTooltip } from "reactstrap";
import BaseAlphanumericInput from "../../../../toolkit/baseAlphanumericInput";
import {
  errorNotification,
  infoNotification,
  successNotification
} from "../../../../utils/notifications";
import { saveMitInteliposDevicesByClubIdRequest } from "../../../actions/clubs";
import { handleRequestError } from "../../../../utils/helpers";

interface Props {
  devices: MitInteliposDevice[];
  isOpen: boolean;
  clubId: string;
  onClose: () => void;
  onSave: (editedDevice: MitInteliposDevice) => void;
}

interface State {
  editingMode: boolean;
  saving: boolean;
  editedDevice: MitInteliposDevice;
}

class ModalClubInteliposDevices extends React.Component<Props, State> {
  state = {
    editingMode: false,
    saving: false,
    editedDevice: null
  };

  columns = [
    {
      Header: () => <p className="font-weight-bold">Sucursal</p>,
      id: 100,
      width: 100,
      className: "text-center",
      accessor: "sucursal"
    },
    {
      Header: () => <p className="font-weight-bold">Usuario</p>,
      id: 200,
      width: 150,
      className: "text-center",
      accessor: "usuario"
    },
    {
      Header: () => <p className="font-weight-bold">No. Serie</p>,
      id: 300,
      width: 200,
      className: "text-center",
      accessor: "numeroSerie"
    },
    {
      Header: () => <p className="font-weight-bold">Nombre</p>,
      id: 400,
      width: 350,
      accessor: "nombre"
    },
    {
      Header: () => {
        return (
          <div className="text-center">
            <Button
              color="link"
              id="btnNewInteliposDevice"
              onClick={e => {
                this.setState({
                  editingMode: true,
                  editedDevice: this.getEmptyMitInteliposDevice()
                });
              }}
              className={`${s.innerButton} ${s.primaryLink}`}
            >
              <FontAwesomeIcon icon={faPlus} />
              <UncontrolledTooltip
                placement="right"
                target={`btnNewInteliposDevice`}
              >
                Agrega datos de dispositivo intelipos
              </UncontrolledTooltip>
            </Button>
          </div>
        );
      },
      id: -300,
      width: 80,
      accessor: "actions",
      Cell: row => {
        return (
          <div>
            <a
              id={`mit-intelipos-device${row.original.id}`}
              onClick={e => {
                e.preventDefault();
                this.setState({
                  editedDevice: { ...row.original },
                  editingMode: true
                });
              }}
            >
              <FontAwesomeIcon
                style={{ cursor: "pointer" }}
                icon={faPencilAlt}
              />
            </a>
          </div>
        );
      }
    }
  ];

  onClose = () => {
    if (!!this.props.onClose) {
      this.props.onClose();
    }
  };

  componentDidMount() {
    this.setState({ editedDevice: this.getEmptyMitInteliposDevice() });
  }

  getMitInteliposDevices = () => {};

  getEmptyMitInteliposDevice = () => {
    return {
      id: null,
      clubId: this.props.clubId,
      sucursal: "",
      usuario: "",
      numeroSerie: "",
      nombre: ""
    };
  };

  onChangeField = fieldName => {
    return event => {
      const value = event.target.value;
      const { editedDevice } = this.state;
      editedDevice[fieldName] = value;
      this.setState({ editedDevice: { ...editedDevice } });
    };
  };

  cancelSaving = () => {
    this.setState({
      editedDevice: null,
      editingMode: false,
      saving: false
    });
  };

  validateData = (editedDevice: MitInteliposDevice) => {
    if (!editedDevice) {
      errorNotification("Debe ingresar todos los datos solicitados");
      return false;
    }
    if (
      !editedDevice.sucursal ||
      !editedDevice.usuario ||
      !editedDevice.numeroSerie ||
      !editedDevice.nombre
    ) {
      errorNotification("Debe ingresar todos los datos solicitados");
      return false;
    }
    return true;
  };

  saveMitInteliposDevices = () => {
    const { editedDevice } = this.state;
    if (!this.validateData(editedDevice)) {
      return;
    }

    infoNotification("Guardando datos del dispositivo...");
    this.setState({ saving: true });

    saveMitInteliposDevicesByClubIdRequest({ ...editedDevice })
      .then(() => {
        successNotification("Datos de dispositivo guardados correctamente");

        this.setState({
          saving: false,
          editingMode: false,
          editedDevice: this.getEmptyMitInteliposDevice()
        });

        if (!!this.props.onSave) {
          this.props.onSave(editedDevice);
        }
      })
      .catch(err => {
        this.setState({ saving: false });
        handleRequestError(err);
      });
  };

  render() {
    return (
      <ModalFrame
        title={`Dispositivos INTELIPOS`}
        isOpen={this.props.isOpen}
        toggle={this.onClose}
        size="lg"
      >
        {!this.state.editingMode && (
          <div>
            {/* <div className="mt-2 text-right">
              <Button
                className="primaryButton"
                onClick={e => {
                  this.setState({
                    editingMode: true,
                    editedDevice: this.getEmptyMitInteliposDevice()
                  });
                }}
                size="sm"
              >
                + Nuevo
              </Button>
            </div> */}
            <ReactTable
              data={this.props.devices || []}
              columns={this.columns}
              className="mt-2 -striped -highlight"
              sortable={false}
              resizable={true}
              showPagination={false}
              pageSize={(this.props.devices || []).length + 1}
            />
          </div>
        )}

        {!!this.state.editingMode && (
          <Container>
            <div className="mt-2">
              <h5>Datos del dispositivo intelipos: </h5>
            </div>
            <div className="mt-2">
              <Row>
                <Col xs={6} md={12} className="pr-0 pt-2">
                  <BaseAlphanumericInput
                    label={"Nombre"}
                    id="nitInteliposNumeroIdentificador"
                    name="nitInteliposNumeroIdentificador"
                    type="text"
                    value={(this.state.editedDevice || {}).nombre || ""}
                    onChange={this.onChangeField("nombre")}
                    maxlength={30}
                    disabled={!!this.state.saving}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={6} md={4} className="pr-0 pt-2">
                  <BaseAlphanumericInput
                    label={"Sucursal"}
                    id="nitInteliposSucursal"
                    name="nitInteliposSucursal"
                    type="text"
                    value={(this.state.editedDevice || {}).sucursal || ""}
                    onChange={this.onChangeField("sucursal")}
                    maxlength={5}
                    disabled={!!this.state.saving}
                  />
                </Col>
                <Col xs={6} md={4} className="pr-0 pt-2">
                  <BaseAlphanumericInput
                    label={"Usuario"}
                    id="nitInteliposUsuario"
                    name="nitInteliposUsuario"
                    type="text"
                    value={(this.state.editedDevice || {}).usuario || ""}
                    onChange={this.onChangeField("usuario")}
                    maxlength={20}
                    disabled={!!this.state.saving}
                  />
                </Col>
                <Col xs={6} md={4} className="pr-0 pt-2">
                  <BaseAlphanumericInput
                    label={"Número serie"}
                    id="nitInteliposNumeroSerie"
                    name="nitInteliposNumeroSerie"
                    type="text"
                    value={(this.state.editedDevice || {}).numeroSerie || ""}
                    onChange={this.onChangeField("numeroSerie")}
                    maxlength={30}
                    disabled={!!this.state.saving}
                  />
                </Col>
              </Row>
            </div>
            <div className="mt-3 text-right">
              <Button
                className="primaryButton ml-3"
                disabled={!!this.state.saving}
                onClick={e => {
                  e.preventDefault();
                  this.saveMitInteliposDevices();
                }}
                size="sm"
              >
                Guardar
              </Button>

              <Button
                className="dangerButton ml-3"
                disabled={!!this.state.saving}
                onClick={e => {
                  e.preventDefault();
                  this.cancelSaving();
                }}
                size="sm"
              >
                Cancelar
              </Button>
            </div>
          </Container>
        )}
      </ModalFrame>
    );
  }
}

export default withStyles(s)(ModalClubInteliposDevices);
